<template>
  <el-dialog
    title="可合并发货单"
    :visible.sync="visible"
    width="960px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-table
      border
      :data="list">
      <el-table-column
        label="发货单号"
        min-width="150"
        fixed="left"
        :resizable="false"
        prop="outOrderCode">
        <template slot-scope="{row}">
          <span v-if="row.createTime">{{ row.outOrderCode }}</span>
          <span
            v-else
            style="color: #f56c6c;">[待创建]</span>
        </template>
      </el-table-column>
      <el-table-column
        label="订单号"
        :resizable="false"
        min-width="150"
        prop="salesOrderCode">
      </el-table-column>
      <el-table-column
        label="收件人"
        :resizable="false"
        min-width="300"
        prop="receiverName">
        <template slot-scope="{row}">
          {{ row.receiverName }}-<span v-if="row.receiverMobile">{{ row.receiverMobile }}</span><span v-if="row.receiverTel">{{ row.receiverTel }}</span>
          <div>{{ row.receiverProvince }}{{ row.receiverCity }}{{ row.receiverDistrict }}{{ row.receiverAddress }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="仓库"
        :resizable="false"
        min-width="130"
        prop="warehouseNo">
        <template slot-scope="{row}"> {{ row.warehouseNo | warehouseName() }}</template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        :resizable="false"
        width="150">
        <template slot-scope="{row}">
          {{ row.createTime | dateformat( ) }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="订单来源"
        width="90"
        :resizable="false">
        <template slot-scope="{row}"> {{ row.source | sourceName() }} </template>
      </el-table-column> -->
    </el-table>
    <el-alert
      style="margin-top: 10px"
      :closable="false"
      title="发货单号为空的单据说明：当前所审订单对应的发货单（提交后生成）。"
      type="warning">
    </el-alert>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="handleSubmit(2)">不合并建单</el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="handleSubmit(3)">合并建单</el-button>
    </template>
  </el-dialog>
</template>

<script>
function noop() {}
export default {
  name: 'CombineOrderModal',
  props: {
    callback: {
      type: Function,
      default: noop
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      list: []
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.list = []
    },
    handleSubmit(flag) {
      this.toggleModal(false)
      this.callback && this.callback(flag)
    },
    fetch(row) {
      this.loading = true
      this.$emit('toggleLoading', true)
      this.$store.dispatch('outstock/outsendadd1', {
        payload: { ...row, addType: 1 },
        success: res => {
          this.loading = false
          this.$emit('toggleLoading', false)
          console.log(res)
          const records = res.data.data
          if (records.length > 0) {
            this.list = records
            this.toggleModal(true)
          } else {
            this.callback && this.callback(2)
          }
        },
        fail: () => {
          this.loading = false
          this.$emit('toggleLoading', false)
        }
      })
    }
  }
}
</script>
